export enum ClientPurposeType {
  Business = "Business",
  Invoice = "Invoice",
  Payment = "Payment",
  Delivery = "Delivery",
  Other = "Other",
  Buyer = "Buyer",
}
